import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "card-title mt-0 mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-end m-3" }

import DisplayDeliveryPlanInformation from '@/components/DailyReportEdit/Split/DisplayDeliveryPlanInformation.vue';
import DailyReportSplitFormDetail from '@/components/DailyReportEdit/Split/SplitFormDetail.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import divideDailyReportsResponse from '@/types/responses/divideDailyReports';
import divideDailyReportsRequest from '@/types/requests/divideDailyReports';
import RegisterModal from '@/components/DailyReportEdit/Split/RegisterModal.vue';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { formatDateTimeWithSeconds } from '@/services/functions';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { useRouter } from 'vue-router';
import { ref, Ref, onMounted, computed, watch } from 'vue';
import i18n from '@/lang/i18n';

type splitReturningAndLeavingTimeType = {
  splitReturningTime: string | null;
  splitLeavingTime: string | null;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'SplitForm',
  props: {
    showFlash: { type: Function },
    deliveryPlanId: {},
    deliveryPlan: {}
  },
  setup(__props: any) {

const { loginWithRedirect } = useAuth();
const router = useRouter();
const splitReturningAndLeavingTime = ref({
  splitReturningTime: null,
  splitLeavingTime: null
} as splitReturningAndLeavingTimeType);
const isLoading: Ref<boolean> = ref(false);
const isRequested: Ref<boolean> = ref(false);
const errorMessages = ref<{
  returning_warehouse_date_time: string[]
  leaving_warehouse_date_time: string[]
  delivery_plan_id: string[]
}>({
  returning_warehouse_date_time: [],
  leaving_warehouse_date_time: [],
  delivery_plan_id: []
});
const isOpenDialog: Ref<boolean> = ref(false);
const isDisplayCompleteModal: Ref<boolean> = ref(false);

const props = __props;

onMounted(() => {
  setLeavingAndReturning();
});

const isActiveExecBtn = computed(() => {
  return !isRequested.value && isRequestableSplitReturningTime() && isRequestableSplitLeavingTime()
})

const execBtnClass = computed(() => {
  return {
    'exec-btn-disabled': !isActiveExecBtn.value
  };
});

function setLeavingAndReturning() {
  splitReturningAndLeavingTime.value.splitReturningTime = props.deliveryPlan.leaving_warehouse_date_time;
  splitReturningAndLeavingTime.value.splitLeavingTime = props.deliveryPlan.returning_warehouse_date_time;
}

function isRequestableSplitReturningTime() {
  return splitReturningAndLeavingTime.value.splitReturningTime
    && splitReturningAndLeavingTime.value.splitLeavingTime
    && new Date(splitReturningAndLeavingTime.value.splitReturningTime) > new Date(props.deliveryPlan.leaving_warehouse_date_time)
    && new Date(splitReturningAndLeavingTime.value.splitReturningTime) < new Date(splitReturningAndLeavingTime.value.splitLeavingTime);
}

function isRequestableSplitLeavingTime() {
  return splitReturningAndLeavingTime.value.splitReturningTime
    && splitReturningAndLeavingTime.value.splitLeavingTime
    && new Date(splitReturningAndLeavingTime.value.splitLeavingTime) < new Date(props.deliveryPlan.returning_warehouse_date_time)
    && new Date(splitReturningAndLeavingTime.value.splitLeavingTime) > new Date(splitReturningAndLeavingTime.value.splitReturningTime);
}

function execSplit() {
  isLoading.value = true;
  Api().divideDailyReports(props.deliveryPlanId, makeRequest(splitReturningAndLeavingTime.value)).then((data: divideDailyReportsResponse) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    isLoading.value = false;
  });
}

function makeRequest(returningAndLeavingTime: splitReturningAndLeavingTimeType): divideDailyReportsRequest {
  return {
    returning_warehouse_date_time: changeFormat(returningAndLeavingTime.splitReturningTime),
    leaving_warehouse_date_time: changeFormat(returningAndLeavingTime.splitLeavingTime)
  }
}

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTimeWithSeconds(new Date(dateTime)) : null;
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
    case 422:
      errorMessages.value = res.data.errors
      if (res.data.errors.delivery_plan_id?.length) {
        isRequested.value = true;
      }
  }
}

function moveDailyReportDisplay() {
  router.push({ name: "DailyReport" })
}

watch(splitReturningAndLeavingTime, () => {
  if (isRequested.value) {
    isRequested.value = false;
    errorMessages.value = {
      returning_warehouse_date_time: [],
      leaving_warehouse_date_time: [],
      delivery_plan_id: []
    };
  }
}, { deep: true });


return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_card, { class: "my-4 pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.title')), 1),
            _createVNode(_component_v_row, { class: "mt-2 mb-4 ml-12" }, {
              default: _withCtx(() => [
                _createVNode(DisplayDeliveryPlanInformation, {
                  deliveryPlan: props.deliveryPlan
                }, null, 8, ["deliveryPlan"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(DailyReportSplitFormDetail, {
                  modelValue: splitReturningAndLeavingTime.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((splitReturningAndLeavingTime).value = $event)),
                  deliveryPlan: props.deliveryPlan,
                  errorMessages: errorMessages.value
                }, null, 8, ["modelValue", "deliveryPlan", "errorMessages"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                class: "ma-2 reset-btn",
                disabled: isLoading.value,
                onClick: moveDailyReportDisplay
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["ma-2 exec-btn", execBtnClass.value]),
                loading: isLoading.value,
                disabled: !isActiveExecBtn.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpenDialog.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.confirmBtn')), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "class"])
            ]),
            _createVNode(ValidationErrors, {
              class: "d-flex justify-content-end",
              messages: errorMessages.value.delivery_plan_id
            }, null, 8, ["messages"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(RegisterModal, {
      title: _unref(i18n).global.t('pages.dailyReports.splitConfirmModal.title'),
      modelValue: isOpenDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDialog).value = $event)),
      deliveryPlan: props.deliveryPlan,
      splitReturningAndLeavingTime: splitReturningAndLeavingTime.value,
      showFlash: props.showFlash,
      execSplit: execSplit
    }, null, 8, ["title", "modelValue", "deliveryPlan", "splitReturningAndLeavingTime", "showFlash"]),
    _createVNode(CompleteModal, {
      modelValue: isDisplayCompleteModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isDisplayCompleteModal).value = $event)),
      messages: [
      _unref(i18n).global.t('pages.dailyReports.splitCompleteModal.messageRow1'),
      _unref(i18n).global.t('pages.dailyReports.splitCompleteModal.messageRow2')
    ],
      moveDailyReportDisplay: moveDailyReportDisplay
    }, null, 8, ["modelValue", "messages"])
  ], 64))
}
}

})